import { FiltersDropdownOption } from '../types'
import { ensureBreakdown, ensureDomain, ensureOrg } from '../helpers/conditions'
import { ReportConfigurationType } from '../enums/report-configuration-type'
import { ReportConfigurationBreakdown } from '../enums/report-configuration-breakdown'
import { ReportConfigurationLevel } from '../enums/report-configuration-level'

const NOTIFICATION_TYPE_FILTER: FiltersDropdownOption = { value: 'NOTIFICATION_SOURCE', label: 'Source' }
const NOTIFICATION_ID_FILTER: FiltersDropdownOption = { value: 'NOTIFICATION_ID', label: 'Notification' }
const NOTIFICATION_KEYWORD_FILTER: FiltersDropdownOption = { value: 'NOTIFICATION_KEYWORDS', label: 'Keywords' }
const NOTIFICATION_TITLE_FILTER: FiltersDropdownOption = { value: 'NOTIFICATION_TITLE', label: 'Title' }
const NOTIFICATION_BODY_FILTER: FiltersDropdownOption = { value: 'NOTIFICATION_BODY', label: 'Body' }
const NOTIFICATION_URL_FILTER: FiltersDropdownOption = { value: 'NOTIFICATION_LANDING_URL', label: 'Landing Url' }
const NOTIFICATION_SEGMENTS_FILTER: FiltersDropdownOption = {
    value: 'NOTIFICATION_SEGMENTS',
    label: 'Segments',
    condition: ensureDomain,
}
const NOTIFICATION_CREATED_BY_FILTER: FiltersDropdownOption = { value: 'NOTIFICATION_CREATED_BY', label: 'Created By' }
const JOURNEY_ID_FILTER: FiltersDropdownOption = { value: 'CAMPAIGN_ID', label: 'Journey' }
const SEGMENTS_ID_FILTER: FiltersDropdownOption = { value: 'SEGMENT_ID', label: 'Segments' }
const PROMPT_ID_FILTER: FiltersDropdownOption = { value: 'PROMPT_ID', label: 'Prompt' }
const TEST_ID_FILTER: FiltersDropdownOption = { value: 'TEST_ID', label: 'A/B Test', condition: ensureDomain }
const BROWSER_FILTER: FiltersDropdownOption = { value: 'BROWSER', label: 'Browser' }
const OS_FILTER: FiltersDropdownOption = { value: 'OPERATING_SYSTEM', label: 'Operating System' }
const PLACEMENT_FILTER: FiltersDropdownOption = { value: 'PLACEMENT', label: 'Device Type' }
const CHANNEL_FILTER: FiltersDropdownOption = { value: 'CHANNEL', label: 'Delivery Channel' }
const APP_MESSAGE_ID_FILTER: FiltersDropdownOption = { value: 'APP_MESSAGE_ID', label: 'App Message' }
const APP_MESSAGE_STYLE_FILTER: FiltersDropdownOption = { value: 'APP_MESSAGE_STYLE', label: 'Style' }
const LIVE_ACTIVITY_ID_FILTER: FiltersDropdownOption = { value: 'ACTIVITY_ID', label: 'Activity ID' }
const CONTENT_SOURCE_FILTER: FiltersDropdownOption = {
    value: 'NOTIFICATION.CONTENT_SOURCE',
    label: 'Content Source',
}
const DOMAIN_FILTER: FiltersDropdownOption = {
    value: 'DOMAIN_ID',
    label: 'Domain',
    // condition: ensureBreakdown('DOMAIN'),
}

const NOTIFICATION_FEAT_FILTER_PACK = [
    NOTIFICATION_BODY_FILTER,
    NOTIFICATION_KEYWORD_FILTER,
    NOTIFICATION_TYPE_FILTER,
    NOTIFICATION_TITLE_FILTER,
    NOTIFICATION_SEGMENTS_FILTER,
    NOTIFICATION_CREATED_BY_FILTER,
    CONTENT_SOURCE_FILTER,
    DOMAIN_FILTER,
]

const NOTIFICATION_FILTER_PACK = [
    NOTIFICATION_ID_FILTER,
    NOTIFICATION_URL_FILTER,
    TEST_ID_FILTER,
    CHANNEL_FILTER,
    ...NOTIFICATION_FEAT_FILTER_PACK,
]

const BROWSER_PLACEMENT_FILTER_PACK = [BROWSER_FILTER, PLACEMENT_FILTER]

const BROWSER_PLACEMENT_OS_FILTER_PACK = [BROWSER_FILTER, PLACEMENT_FILTER, OS_FILTER]

const BROWSER_OS_FILTER_PACK = [BROWSER_FILTER, OS_FILTER]

const PLACEMENT_OS_FILTER_PACK = [PLACEMENT_FILTER, OS_FILTER]

const APP_MESSAGE_FILTER_PACK = [APP_MESSAGE_ID_FILTER, APP_MESSAGE_STYLE_FILTER]

const PACK = []

type FilterKey = `${ReportConfigurationType}_${ReportConfigurationLevel}_${ReportConfigurationBreakdown}`

export const FILTER_DROPDOWN_OPTIONS: Partial<Record<FilterKey, FiltersDropdownOption[]>> = {
    NONE_NONE_NONE: [],

    DELIVERY_DOMAIN_CHANNEL: [...NOTIFICATION_FEAT_FILTER_PACK, CHANNEL_FILTER],
    DELIVERY_DOMAIN_NONE: [...NOTIFICATION_FEAT_FILTER_PACK, CHANNEL_FILTER],
    DELIVERY_DOMAIN_BUTTON: [...NOTIFICATION_FEAT_FILTER_PACK],
    DELIVERY_DOMAIN_BROWSER: [...NOTIFICATION_FEAT_FILTER_PACK, BROWSER_FILTER],
    'DELIVERY_DOMAIN_BROWSER,PLACEMENT': [...NOTIFICATION_FEAT_FILTER_PACK, ...BROWSER_PLACEMENT_FILTER_PACK],
    'DELIVERY_DOMAIN_BROWSER,PLACEMENT,OPERATING_SYSTEM': [
        ...NOTIFICATION_FEAT_FILTER_PACK,
        ...BROWSER_PLACEMENT_OS_FILTER_PACK,
    ],
    'DELIVERY_DOMAIN_BROWSER,OPERATING_SYSTEM': [...NOTIFICATION_FEAT_FILTER_PACK, ...BROWSER_OS_FILTER_PACK],
    DELIVERY_DOMAIN_OPERATING_SYSTEM: [...NOTIFICATION_FEAT_FILTER_PACK, OS_FILTER],
    DELIVERY_DOMAIN_PLACEMENT: [...NOTIFICATION_FEAT_FILTER_PACK, PLACEMENT_FILTER],
    'DELIVERY_DOMAIN_PLACEMENT,CHANNEL': [...NOTIFICATION_FEAT_FILTER_PACK],
    'DELIVERY_DOMAIN_PLACEMENT,OPERATING_SYSTEM': [...NOTIFICATION_FEAT_FILTER_PACK, ...PLACEMENT_OS_FILTER_PACK],
    DELIVERY_ORGANIZATION_NONE: [...NOTIFICATION_FILTER_PACK],
    DELIVERY_NOTIFICATION_NONE: [...NOTIFICATION_FILTER_PACK],
    DELIVERY_NOTIFICATION_CHANNEL: [...NOTIFICATION_FEAT_FILTER_PACK, CHANNEL_FILTER],
    DELIVERY_NOTIFICATION_BUTTON: [...NOTIFICATION_FILTER_PACK],
    DELIVERY_NOTIFICATION_BROWSER: [...NOTIFICATION_FILTER_PACK, BROWSER_FILTER],
    'DELIVERY_NOTIFICATION_BROWSER,PLACEMENT': [...NOTIFICATION_FILTER_PACK, ...BROWSER_PLACEMENT_FILTER_PACK],
    'DELIVERY_NOTIFICATION_BROWSER,PLACEMENT,OPERATING_SYSTEM': [
        ...NOTIFICATION_FILTER_PACK,
        ...BROWSER_PLACEMENT_OS_FILTER_PACK,
    ],
    DELIVERY_NOTIFICATION_DOMAIN: [...NOTIFICATION_FILTER_PACK],
    'DELIVERY_NOTIFICATION_DOMAIN,PLACEMENT': [...NOTIFICATION_FILTER_PACK],
    [`${ReportConfigurationType.DELIVERY}_${ReportConfigurationLevel.NOTIFICATION}_${ReportConfigurationBreakdown.DOMAIN_CHANNEL_PLACEMENT}`]:
        [...NOTIFICATION_FILTER_PACK],
    'DELIVERY_NOTIFICATION_BROWSER,OPERATING_SYSTEM': [...NOTIFICATION_FILTER_PACK, ...BROWSER_OS_FILTER_PACK],
    DELIVERY_NOTIFICATION_OPERATING_SYSTEM: [...NOTIFICATION_FILTER_PACK, OS_FILTER],
    DELIVERY_NOTIFICATION_PLACEMENT: [...NOTIFICATION_FILTER_PACK, PLACEMENT_FILTER],
    'DELIVERY_NOTIFICATION_PLACEMENT,OPERATING_SYSTEM': [...NOTIFICATION_FILTER_PACK, ...PLACEMENT_OS_FILTER_PACK],
    DELIVERY_TEST_NONE: [TEST_ID_FILTER, CHANNEL_FILTER],
    DELIVERY_TEST_CHANNEL: [...NOTIFICATION_FEAT_FILTER_PACK, CHANNEL_FILTER],
    DELIVERY_TEST_BROWSER: [TEST_ID_FILTER, BROWSER_FILTER],
    'DELIVERY_TEST_BROWSER,PLACEMENT': [TEST_ID_FILTER, ...BROWSER_PLACEMENT_FILTER_PACK],
    'DELIVERY_TEST_BROWSER,PLACEMENT,OPERATING_SYSTEM': [TEST_ID_FILTER, ...BROWSER_PLACEMENT_OS_FILTER_PACK],
    'DELIVERY_TEST_BROWSER,OPERATING_SYSTEM': [TEST_ID_FILTER, ...BROWSER_OS_FILTER_PACK],
    DELIVERY_TEST_OPERATING_SYSTEM: [TEST_ID_FILTER, OS_FILTER],
    DELIVERY_TEST_PLACEMENT: [TEST_ID_FILTER, PLACEMENT_FILTER],
    'DELIVERY_TEST_PLACEMENT,OPERATING_SYSTEM': [TEST_ID_FILTER, ...PLACEMENT_OS_FILTER_PACK],
    DELIVERY_CAMPAIGN_NONE: [JOURNEY_ID_FILTER],
    DELIVERY_CAMPAIGN_VARIANT: [JOURNEY_ID_FILTER],
    DELIVERY_CAMPAIGN_SPLIT_TEST: [JOURNEY_ID_FILTER],
    DELIVERY_CAMPAIGN_STEP: [JOURNEY_ID_FILTER],
    DELIVERY_SEGMENT_NONE: [SEGMENTS_ID_FILTER],
    DELIVERY_SEGMENT_CHANNEL: [...NOTIFICATION_FEAT_FILTER_PACK, SEGMENTS_ID_FILTER],
    DELIVERY_SEGMENT_PLACEMENT: [SEGMENTS_ID_FILTER],
    DELIVERY_KEYWORD_NONE: [CHANNEL_FILTER],
    DELIVERY_KEYWORD_CHANNEL: [CHANNEL_FILTER],
    SUBSCRIBER_ORGANIZATION_NONE: [],
    SUBSCRIBER_ORGANIZATION_DOMAIN: [DOMAIN_FILTER],
    [`${ReportConfigurationType.SUBSCRIBER}_${ReportConfigurationLevel.ORGANIZATION}_${ReportConfigurationBreakdown.NONE}`]:
        [DOMAIN_FILTER],
    [`${ReportConfigurationType.SUBSCRIBER}_${ReportConfigurationLevel.ORGANIZATION}_${ReportConfigurationBreakdown.DOMAIN}`]:
        [],
    [`${ReportConfigurationType.SUBSCRIBER}_${ReportConfigurationLevel.ORGANIZATION}_${ReportConfigurationBreakdown.CHANNEL}`]:
        [DOMAIN_FILTER, CHANNEL_FILTER],
    [`${ReportConfigurationType.SUBSCRIBER}_${ReportConfigurationLevel.ORGANIZATION}_${ReportConfigurationBreakdown.DOMAIN_CHANNEL}`]:
        [],
    [`${ReportConfigurationType.SUBSCRIBER}_${ReportConfigurationLevel.ORGANIZATION}_${ReportConfigurationBreakdown.PLACEMENT_CHANNEL}`]:
        [DOMAIN_FILTER, PLACEMENT_FILTER, CHANNEL_FILTER],
    [`${ReportConfigurationType.SUBSCRIBER}_${ReportConfigurationLevel.ORGANIZATION}_${ReportConfigurationBreakdown.DOMAIN_CHANNEL_PLACEMENT}`]:
        [],
    SUBSCRIBER_DOMAIN_NONE: [],
    SUBSCRIBER_DOMAIN_BROWSER: [BROWSER_FILTER],
    'SUBSCRIBER_DOMAIN_BROWSER,PLACEMENT': [...BROWSER_PLACEMENT_FILTER_PACK],
    'SUBSCRIBER_DOMAIN_BROWSER,PLACEMENT,OPERATING_SYSTEM': [...BROWSER_PLACEMENT_OS_FILTER_PACK],
    'SUBSCRIBER_DOMAIN_BROWSER,OPERATING_SYSTEM': [...BROWSER_OS_FILTER_PACK],
    SUBSCRIBER_DOMAIN_OPERATING_SYSTEM: [OS_FILTER],
    SUBSCRIBER_DOMAIN_PLACEMENT: [PLACEMENT_FILTER],
    'SUBSCRIBER_DOMAIN_PLACEMENT,OPERATING_SYSTEM': [...PLACEMENT_OS_FILTER_PACK],
    SUBSCRIBER_PROMPT_NONE: [PROMPT_ID_FILTER, TEST_ID_FILTER],
    SUBSCRIBER_PROMPT_BROWSER: [PROMPT_ID_FILTER, BROWSER_FILTER, TEST_ID_FILTER],
    'SUBSCRIBER_PROMPT_BROWSER,PLACEMENT': [PROMPT_ID_FILTER, TEST_ID_FILTER, ...BROWSER_PLACEMENT_FILTER_PACK],
    'SUBSCRIBER_PROMPT_BROWSER,PLACEMENT,OPERATING_SYSTEM': [
        PROMPT_ID_FILTER,
        TEST_ID_FILTER,
        ...BROWSER_PLACEMENT_OS_FILTER_PACK,
    ],
    'SUBSCRIBER_PROMPT_BROWSER,OPERATING_SYSTEM': [PROMPT_ID_FILTER, TEST_ID_FILTER, ...BROWSER_OS_FILTER_PACK],
    SUBSCRIBER_PROMPT_OPERATING_SYSTEM: [PROMPT_ID_FILTER, TEST_ID_FILTER, OS_FILTER],
    SUBSCRIBER_PROMPT_PLACEMENT: [PROMPT_ID_FILTER, TEST_ID_FILTER, PLACEMENT_FILTER],
    'SUBSCRIBER_PROMPT_PLACEMENT,OPERATING_SYSTEM': [PROMPT_ID_FILTER, TEST_ID_FILTER, ...PLACEMENT_OS_FILTER_PACK],
    SUBSCRIBER_TEST_NONE: [TEST_ID_FILTER],
    SUBSCRIBER_TEST_BROWSER: [TEST_ID_FILTER, BROWSER_FILTER],
    'SUBSCRIBER_TEST_BROWSER,PLACEMENT': [TEST_ID_FILTER, ...BROWSER_PLACEMENT_FILTER_PACK],
    'SUBSCRIBER_TEST_BROWSER,PLACEMENT,OPERATING_SYSTEM': [TEST_ID_FILTER, ...BROWSER_PLACEMENT_OS_FILTER_PACK],
    'SUBSCRIBER_TEST_BROWSER,OPERATING_SYSTEM': [TEST_ID_FILTER, ...BROWSER_OS_FILTER_PACK],
    SUBSCRIBER_TEST_OPERATING_SYSTEM: [TEST_ID_FILTER, OS_FILTER],
    SUBSCRIBER_TEST_PLACEMENT: [TEST_ID_FILTER, PLACEMENT_FILTER],
    'SUBSCRIBER_TEST_PLACEMENT,OPERATING_SYSTEM': [TEST_ID_FILTER, ...PLACEMENT_OS_FILTER_PACK],
    APP_MESSAGE_DOMAIN_NONE: [CHANNEL_FILTER],
    APP_MESSAGE_DOMAIN_CHANNEL: [CHANNEL_FILTER],
    APP_MESSAGE_DOMAIN_PLACEMENT: [PLACEMENT_FILTER],
    APP_MESSAGE_APP_MESSAGE_NONE: [...APP_MESSAGE_FILTER_PACK, CHANNEL_FILTER],
    APP_MESSAGE_APP_MESSAGE_CHANNEL: [...APP_MESSAGE_FILTER_PACK, CHANNEL_FILTER],
    APP_MESSAGE_APP_MESSAGE_PLACEMENT: [...APP_MESSAGE_FILTER_PACK, PLACEMENT_FILTER],

    PUB_NETWORK_DOMAIN_NONE: [],

    LIVE_ACTIVITY_ACTIVITY_NONE: [LIVE_ACTIVITY_ID_FILTER],
}
